// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-arrow-od {
  font-size: 50px;
}

.right-arrow-od svg {
  color: var(--black) !important;
}

.order-no-date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: flex-start;
}

.order-number h4,
.order-date h4 {
  font-weight: 700;
  text-transform: uppercase;
}

.delivery-method {
  padding: 20px 10px;
}

.delivery-method h4,
.order-info h4 {
  font-weight: 700;
}

.status-done svg {
  color: var(--black);
  margin-right: 10px;
  font-size: 45px;
}

.order-info h4 {
  display: flex;
  align-items: center;
}

.order-info .status-done {
  position: relative;
  margin-right: 8px;
}

.order-info .status-done::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 100%;
  background-color: var(--black);
  left: calc(50% - 7px);
  top: 85%;
}

.order-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2%;
}

.order-delivered img {
  height: 40px;
  width: 40px;
  margin-right: 20px;
}

.rr-review-btn {
  display: flex;
  column-gap: 50px;
}

.rate-review-btn,
.return-btn {
  border-radius: 50px;
  padding: 10px 25px;
  font-size: 18px;
  font-weight: 700;
}

.return-btn {
  background-color: transparent;
  background-color: initial;
  color: var(--dPink);
  border: 2px solid #977cff;
}

.customer-name p {
  margin-bottom: 0px;
}

/* Receipt Button */
.receipt-btn {
  background-color: var(--dBlue);
  color: var(--white);
  border-radius: 50px;
  font-size: 18px;
  padding: 10px 25px;
}

.size-warning {
  padding-top: 5px;
}

.purchased-order-name {
  font-size: 18px;
  font-weight: 500;
}

.purchased-order-id {
  font-size: 14px;
  color: var(--grey);
  padding-left: 7%;
}

.order-list-wrapper {
  box-shadow: 0px 0px 17px -3px #ccc;
  padding: 40px;
  margin: 20px auto;
  padding-bottom: 0;
}

@media (max-width: 1024px) {
  .order-info {
    padding-bottom: 4%;
  }
}

@media (max-width: 767px) {
  .order-number h4,
  .order-date h4,
  .delivery-method h4,
  .status-txt h4 {
    font-size: 18px;
  }

  .status-done svg {
    font-size: 30px;
  }

  .order-receive-date p {
    margin-bottom: 0.5rem;
  }

  .order-delivered img {
    height: 30px;
    width: 30px;
  }

  .order-info .status-done::after {
    height: 100%;
    left: calc(50% - 6px);
    top: 90%;
  }

  .order-info {
    padding-bottom: 5%;
  }

  .rr-review-btn {
    column-gap: 30px;
  }

  .rate-review-btn,
  .return-btn {
    border-radius: 30px;
    padding: 5px 15px;
    font-size: 16px;
    font-weight: 700;
  }

  .receipt-btn {
    margin-top: 20px;
  }

  .customer-billing-add {
    padding-top: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/order-details-pg/OrderDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAAuB;EAAvB,yBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".right-arrow-od {\r\n  font-size: 50px;\r\n}\r\n\r\n.right-arrow-od svg {\r\n  color: var(--black) !important;\r\n}\r\n\r\n.order-no-date {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  align-items: flex-start;\r\n}\r\n\r\n.order-number h4,\r\n.order-date h4 {\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.delivery-method {\r\n  padding: 20px 10px;\r\n}\r\n\r\n.delivery-method h4,\r\n.order-info h4 {\r\n  font-weight: 700;\r\n}\r\n\r\n.status-done svg {\r\n  color: var(--black);\r\n  margin-right: 10px;\r\n  font-size: 45px;\r\n}\r\n\r\n.order-info h4 {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.order-info .status-done {\r\n  position: relative;\r\n  margin-right: 8px;\r\n}\r\n\r\n.order-info .status-done::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 2px;\r\n  height: 100%;\r\n  background-color: var(--black);\r\n  left: calc(50% - 7px);\r\n  top: 85%;\r\n}\r\n\r\n.order-info {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 2%;\r\n}\r\n\r\n.order-delivered img {\r\n  height: 40px;\r\n  width: 40px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.rr-review-btn {\r\n  display: flex;\r\n  column-gap: 50px;\r\n}\r\n\r\n.rate-review-btn,\r\n.return-btn {\r\n  border-radius: 50px;\r\n  padding: 10px 25px;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n}\r\n\r\n.return-btn {\r\n  background-color: unset;\r\n  color: var(--dPink);\r\n  border: 2px solid #977cff;\r\n}\r\n\r\n.customer-name p {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n/* Receipt Button */\r\n.receipt-btn {\r\n  background-color: var(--dBlue);\r\n  color: var(--white);\r\n  border-radius: 50px;\r\n  font-size: 18px;\r\n  padding: 10px 25px;\r\n}\r\n\r\n.size-warning {\r\n  padding-top: 5px;\r\n}\r\n\r\n.purchased-order-name {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n\r\n.purchased-order-id {\r\n  font-size: 14px;\r\n  color: var(--grey);\r\n  padding-left: 7%;\r\n}\r\n\r\n.order-list-wrapper {\r\n  box-shadow: 0px 0px 17px -3px #ccc;\r\n  padding: 40px;\r\n  margin: 20px auto;\r\n  padding-bottom: 0;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .order-info {\r\n    padding-bottom: 4%;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .order-number h4,\r\n  .order-date h4,\r\n  .delivery-method h4,\r\n  .status-txt h4 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .status-done svg {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .order-receive-date p {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .order-delivered img {\r\n    height: 30px;\r\n    width: 30px;\r\n  }\r\n\r\n  .order-info .status-done::after {\r\n    height: 100%;\r\n    left: calc(50% - 6px);\r\n    top: 90%;\r\n  }\r\n\r\n  .order-info {\r\n    padding-bottom: 5%;\r\n  }\r\n\r\n  .rr-review-btn {\r\n    column-gap: 30px;\r\n  }\r\n\r\n  .rate-review-btn,\r\n  .return-btn {\r\n    border-radius: 30px;\r\n    padding: 5px 15px;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .receipt-btn {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .customer-billing-add {\r\n    padding-top: 30px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
